import PlantMapView from './PlantMapView';

export default PlantMapView;
